import { rootStateBranchSelector } from '../../../utils/rootStateBranchSelector';

export const pageDataSelector = rootStateBranchSelector('pageData');
